import { styled, Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  appBar: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '8rem',
    top: '0',
  },
  menuItems: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'underline',
    textUnderlinePosition: 'under',
    marginRight: '3rem',
  },
  title: {
    fontSize: 18,
    color: theme.palette.primary.main,
  },
  arrow: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    marginLeft: '0.5rem',
  },
  measurementDateHeader: {
    maxWidth: '7rem',
    height: '4.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  bottomSection: {
    backgroundColor: theme.palette.primary[600],
    borderTop: '1px solid',
    borderColor: 'divider',
    py: 1,
    px: 2
  }
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#80A4C5',
  fontSize: '12px',
  fontWeight: 600,
  minWidth: 0,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,

  '&:hover': {
    color: theme.palette.common.white,
  },

  '&.Mui-selected': {
    color: `${theme.palette.common.white} !important`,
  },
}));